import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AnulacionBoletaHonorario } from "src/app/models/BoletaHonorarios/AnulacionBoletaHonorario.enum";
import { BoletaHonorariosEmitida } from "src/app/models/BoletaHonorarios/BoletaHonorariosEmitida";
import { BoletaHonorarioRequest } from "src/app/models/BoletaHonorarios/BoletaHonorariosRequest";
import { TipoAnulacionBhe } from "src/app/models/BoletaHonorarios/TipoAnulacionBhe";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Component({
   selector: "app-anulador-bhe",
   templateUrl: "./anulador-bhe.component.html",
   styleUrls: ["./anulador-bhe.component.scss"],
})
export class AnuladorBheComponent implements OnInit {
   @Input() public bheEmitida: BoletaHonorariosEmitida;
   @Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
   @Output() private sendNullifyBHERequest: EventEmitter<any> = new EventEmitter<any>();
   public anulacionBheSource: TipoAnulacionBhe[] = this.localStorage.getTipoAnulacionBhe();
   public anulacionBheFormGroup: FormGroup;
   private anulacionRequest: BoletaHonorarioRequest = new BoletaHonorarioRequest();

   constructor(private localStorage: LocalStorageService, private formBuilder: FormBuilder) {
      this.setForm();
   }

   ngOnInit(): void {}
   sendCloseRequest() {
      this.sendCloseRequestEmitter.emit();
   }

   sendRequest(req: BoletaHonorarioRequest) {
      this.sendNullifyBHERequest.emit(req);
   }

   setForm() {
      this.anulacionBheFormGroup = this.formBuilder.group({
         motivoAnulacion: [, Validators.required],
      });
   }
   onSubmit() {
      if (this.anulacionBheFormGroup.valid) {
         let motivo: TipoAnulacionBhe = this.anulacionBheFormGroup.controls.motivoAnulacion.value;
         this.anulacionRequest.BH = this.bheEmitida;
         this.anulacionRequest.Motivo = AnulacionBoletaHonorario[motivo.nombre];
         this.sendRequest(this.anulacionRequest);
      }
   }

   setMotivoChange() {}
}
